export default {
  /**
  * Работа со случайными значениями
  * @mixin
  * @alias random
  */
  methods: {
    /**
    * Получить случайное число
    * @param {Number} min - минимальное число
    * @param {Number} max - максимальное число
    * @return {Number} Результат
    */
    $_random(min = 0, max = 1) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    /**
    * Получить случайну дату
    * @param {Date} start - минимальная дата
    * @param {Date} end - максимальная дата
    * @return {Date} Результат
    */
    $_randomDate(start = new Date(null), end = new Date()) {
      return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()))
    },
    /**
    * Получить случайный набор символов
    * @param {Number} len - Длина строки
    * @return {String} Результат
    */
    $_randomSymbol(len = 4) {
      return [...Array(len)].map(() => (~~(Math.random() * 36)).toString(36)).join('')
    },
    /**
    * Получить случайный набор буквенных символов
    * @param {Number} len - Длина строки
    * @return {String} Результат
    */
    $_randomLetter(len = 4) {
      return [...Array(len)].map(() => (Math.random() * 36).toString(36).match(/[a-zA-Z]/)[0]  ).join('')
    },
    /**
    * Генерируем уникальный идентификатор
    * @param {Number} count - Количество блоков
    * @param {String} separator - Символ разделитель
    */
    $_createGuid(count = 5, separator = '-',) {
      let result = this.$_randomSymbol()
      for (let i = 1; i < count; i++) {
        result += `${separator}${this.$_randomSymbol()}`
      }
      return result
    },
  },
}
